import React, { useState } from 'react';

import InteractiveInput from 'components/InteractiveInput/InteractiveInput';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PulseNumberRatingPreview = ({ question }) => {
  const [selectedId, setSelectedId] = useState();

  const handleChange = (newOption) => {
    setSelectedId(newOption);
  };

  return (
    <Wrapper>
      <InteractiveInput
        data={question.answerOptions}
        type={question.answerType}
        size={question.answerOptions.length > 6 ? 'small' : 'medium'}
        selectedId={selectedId}
        onSelect={handleChange}
      />
    </Wrapper>
  );
};

export default PulseNumberRatingPreview;
